import { Cards } from '../../components/gradient-layout/cards';
import { GoogleLogin } from './google-login';
import { PasswordLogin } from './password-login';

import commonStyles from '../public.module.scss';

export const LoginCards = () => (
  <Cards>
    <GoogleLogin />
    <div className={commonStyles.separator}>or</div>
    <PasswordLogin />
  </Cards>
);
